import React from 'react';
import get from 'lodash/get';
import './cornerstone-widget.module.scss';

import { ErrorBoundary } from './components';

import Certifications from './widgets/certifications';
import MyTraining from './widgets/my-training';
import NotFound from './widgets/not-found';
import YourActionItems from './widgets/your-action-items';
import YourAssignedTraining from './widgets/your-assigned-training';
import YourTranscript from './widgets/your-transcript';
import TrainingInProgress from './widgets/training-in-progress';
import YourInbox from './widgets/your-inbox';
import SocialFeed from './widgets/social-feed';
import YourTasks from './widgets/your-tasks';
import YourUpcomingSessions from './widgets/your-upcoming-sessions';

const DEFAULT_WIDTH_VALUE = 60;

const widgets = Object.freeze({
  'certifications': Certifications,
  'my-training': MyTraining,
  'your-transcript': YourTranscript,
  'your-assigned-training': YourAssignedTraining,
  'your-action-items': YourActionItems,
  'training-in-progress': TrainingInProgress,
  'your-inbox': YourInbox,
  'social-feed': SocialFeed,
  'your-tasks': YourTasks,
  'your-upcoming-sessions': YourUpcomingSessions
});

const CornerstoneWidgetBlock = (props) => {
  const { contentFields } = props;

  const fields = contentFields.reduce((acc, curr) => ({
    ...acc,
    [curr.fieldDefinitionKey]: { ...curr }
  }), {});

  const widgetId = get(fields, 'Widget.data');
  const title = get(fields, 'Title.data');
  const width = get(fields, 'Width.data') || DEFAULT_WIDTH_VALUE;

  const renderWidget = () => {
    const widgetProps = { title };
    const Widget = widgets[widgetId] || NotFound;
    return <Widget {...widgetProps} />
  };


  return (
    <section className={`w--${width} show--shadow`}>
      <ErrorBoundary>
        {
          renderWidget()
        }
      </ErrorBoundary>
    </section>
  );
};

export default CornerstoneWidgetBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/cornerstone-widget-block.js